module.exports = __webpack_public_path__ + "static/img/bg.7198d9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/bg.jpg
// module id = i+mH
// module chunks = 0